"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ICONS_ID = exports.COLOR = exports.SVG_ICON_KIND = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.log-utils");

var _SvgIconLibrary = _interopRequireDefault(require("./SvgIconLibrary"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SVG_ICON_KIND = {
  LIGHT: 'L',
  MEDIUM: 'M',
  SOLID: 'S'
};
exports.SVG_ICON_KIND = SVG_ICON_KIND;
var COLOR = {
  BLACK: 'black',
  WHITE: 'white',
  GREEN: 'green',
  GREY_7: 'grey7',
  ORANGE: 'orange',
  BLUE: 'blue',
  PIPPER: 'pipper',
  INHERIT: 'inherit',
  EMP_DARK_BLUE: 'emp-dark-blue'
};
exports.COLOR = COLOR;
var ICONS_ID = {
  Abierto: 'Abierto',
  Ahorro: 'Ahorro',
  AhorroMovil: 'AhorroMovil-movil',
  Ajustes: 'Ajustes',
  Alerta: 'Alerta',
  AMC: 'AMC',
  AnadirMas: 'AnadirMas',
  Apagar: 'Apagar',
  ArrowLeftRight: 'ArrowLeftRight-left-right',
  AtClientes: 'AtClientes-clientes',
  Aura: 'Aura',
  Auriculares: 'Auriculares',
  Ayuda: 'Ayuda',
  AyudaPregunta: 'AyudaPregunta',
  BBDD: 'BBDD',
  Blog: 'Blog',
  Buscar: 'Buscar',
  Calendario: 'Calendario',
  CalidadDeServicio: 'CalidadDeServicio',
  CanalCero: 'CanalCero',
  CallCenter: 'CallCenter',
  CalleTrece: 'CalleTrece',
  Campana: 'Campana',
  Cerrar: 'Cerrar',
  Chat: 'Chat',
  Cheuron: 'Cheuron',
  CircleCheuron: 'CircleCheuron',
  Cine: 'Cine',
  CineIcon: 'CineIcon',
  CineN: 'CineN',
  CineRock: 'CineRock',
  ClaveWifi: 'ClaveWifi',
  Clic: 'Clic',
  Cloud: 'Cloud',
  Comedia: 'Comedia',
  ComedyCentral: 'ComedyCentral',
  Compartir: 'Compartir',
  Comprar: 'Comprar',
  ComprarPlanes: 'ComprarPlanes',
  CompraSegura: 'CompraSegura',
  ComprarDatos: 'ComprarDatos',
  ConfianzaOnline: 'ConfianzaOnline',
  Configuracion: 'Configuracion',
  ConfiguracionCorreo: 'ConfiguracionCorreo',
  ConfiguracionRouter: 'ConfiguracionRouter',
  ConfigurarMovil: 'ConfigurarMovil',
  ConsultaCanjes: 'ConsultaCanjes',
  ConsultaDocumento: 'ConsultaDocumento',
  Consumo: 'Consumo',
  CorazonSalud: 'CorazonSalud',
  Dark: 'Dark',
  Datos: 'Datos',
  Deporte: 'Deporte',
  Deporte1: 'Deporte1',
  Deporte2: 'Deporte2',
  DeporteIcon: 'DeporteIcon',
  Descargar: 'Descargar',
  DescargarApp: 'DescargarApp-app',
  Desco: 'Desco',
  DescoMando: 'DescoMando-mando',
  DetalleLlamadas: 'DetalleLlamadas',
  Dialogando: 'Dialogando',
  Dinero: 'Dinero',
  Directorio: 'Directorio',
  Disney: 'Disney',
  Documento: 'Documento',
  Ecologico: 'Ecologico',
  Envio: 'Envio',
  Error: 'Error',
  Estrenos: 'Estrenos',
  Euro: 'Euro',
  EuroCirculo: 'EuroCirculo',
  Eurosport: 'Eurosport',
  Facebook: 'Facebook',
  Factura: 'Factura',
  Favorito: 'Favorito',
  Fibra: 'Fibra',
  Fijo: 'Fijo',
  FijoInternet: 'FijoInternet',
  Filtro: 'Filtro',
  Formula1: 'Formula1',
  Foro: 'Foro',
  Fox: 'Fox',
  FoxLife: 'FoxLife',
  FundacionTelefonica: 'FundacionTelefonica',
  Fusion: 'Fusion',
  FutbolIcon: 'FutbolIcon',
  Futbol: 'Futbol',
  Grabar: 'Grabar',
  Global: 'Global',
  Golf: 'Golf',
  Hgu: 'Hgu',
  Hollywood: 'Hollywood',
  Home: 'Home',
  HomeDoor: 'HomeDoor',
  Juego: 'Juego',
  Informacion: 'Informacion',
  Instagram: 'Instagram',
  Internet: 'Internet',
  InternetMovil: 'InternetMovil',
  Lanzamiento: 'Lanzamiento',
  LaLiga: 'LaLiga',
  LigaCampeones: 'LigaCampeones',
  LineaAdicional: 'LineaAdicional',
  Linkedin: 'Linkedin',
  LlamadaEntrante: 'LlamadaEntrante',
  LlamadaEspera: 'LlamadaEspera',
  LlamadaSaliente: 'LlamadaSaliente',
  Mas80: 'Mas80',
  MensDictados: 'MensDictados',
  MeGusta: 'MeGusta',
  MisPedidos: 'MisPedidos',
  Motor: 'Motor',
  MotorIcon: 'MotorIcon',
  Movil: 'Movil',
  Movistar: 'Movistar',
  MovistarCar: 'MovistarCar',
  MovistarCircular: 'MovistarCircular',
  MovistarLikes: 'MovistarLikes',
  MovistarPlus: 'MovistarPlus',
  MpaUp: 'MpaUp',
  Multicontenido: 'Multicontenido',
  Multipantalla: 'Multipantalla',
  Noticias: 'Noticias',
  NoVer: 'NoVer',
  Nube: 'Nube',
  Nubico: 'Nubico',
  Oferta: 'Oferta',
  OfertasExclusivas: 'OfertasExclusivas',
  Ok: 'Ok',
  Ont: 'Ont',
  Opciones: 'Opciones',
  PagarFacturas: 'PagarFacturas',
  PagoOnline: 'PagoOnline',
  Partidazo: 'Partidazo',
  Perfil: 'Perfil',
  Play: 'Play',
  Portatil: 'Portatil',
  PriorityUser: 'PriorityUser',
  Producto: 'Producto',
  Qustodio: 'Qustodio',
  RealMadrid: 'RealMadrid',
  RechazoLlamada: 'RechazoLlamada',
  Reloj: 'Reloj',
  Router: 'Router',
  Seguridad: 'Seguridad',
  SeguridadAbierta: 'SeguridadAbierta',
  SeriesMania: 'SeriesMania',
  SeguroMovil: 'SeguroMovil',
  Series: 'Series',
  SeriesIcon: 'SeriesIcon',
  SeriesExtras: 'SeriesExtras',
  ServicioTecnicoMovil: 'ServicioTecnicoMovil',
  Sim: 'Sim',
  SinConexion: 'SinConexion',
  Sms: 'Sms',
  SoporteTecnico: 'SoporteTecnico',
  Star: 'Star',
  SundanceTv: 'SundanceTv',
  SYFY: 'SYFY',
  TarjetaCredito: 'TarjetaCredito',
  TaquillaUp: 'TaquillaUp',
  TCM: 'TCM',
  Tokens: 'Tokens',
  Telefonica: 'Telefonica',
  TelefonicaFanshop: 'TelefonicaFanshop',
  Tiendas: 'Tiendas',
  Tuenti: 'Tuenti',
  Ubicacion: 'Ubicacion',
  UHD: 'UHD',
  U7D: 'U7D',
  Tv: 'Tv',
  Twitter: 'Twitter',
  Usuario: 'Usuario',
  Vamos: 'Vamos',
  Ver: 'Ver',
  Video: 'Video',
  ViolenciaDeGenero: 'ViolenciaDeGenero',
  WhatsappBlue: 'WhatsappBlue',
  WhatsappGreen: 'WhatsappGreen',
  Xtra: 'Xtra',
  Youtube: 'Youtube'
};
exports.ICONS_ID = ICONS_ID;

var SVGIconLoader = function SVGIconLoader(props) {
  var id = props.id;
  var SVGComponent = _SvgIconLibrary["default"][id];

  if (SVGComponent) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react["default"].Suspense, {
      fallback: null,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SVGComponent, _objectSpread({}, props))
    });
  }

  (0, _gerenciatdUtils.errorLog)('[SvgIconLoader]: Sorry your id is not valid');
  return null;
};

SVGIconLoader.propTypes = {
  /**
  * {
  *  "info": "Establece el icono que se va a utilizar",
  *  "kind": "both",
  *  "beautifulName": "Icono id",
  *  "injectComponent": ""
  * }
  */
  id: _propTypes["default"].oneOf([ICONS_ID.Abierto, ICONS_ID.Ahorro, ICONS_ID.AhorroMovil, ICONS_ID.Ajustes, ICONS_ID.Alerta, ICONS_ID.AMC, ICONS_ID.AnadirMas, ICONS_ID.Apagar, ICONS_ID.ArrowLeftRight, ICONS_ID.AtClientes, ICONS_ID.Aura, ICONS_ID.Auriculares, ICONS_ID.Ayuda, ICONS_ID.AyudaPregunta, ICONS_ID.BBDD, ICONS_ID.Blog, ICONS_ID.Buscar, ICONS_ID.Calendario, ICONS_ID.CalidadDeServicio, ICONS_ID.CanalCero, ICONS_ID.Callcenter, ICONS_ID.CalleTrece, ICONS_ID.Campana, ICONS_ID.Cerrar, ICONS_ID.Chat, ICONS_ID.Cheuron, ICONS_ID.CircleCheuron, ICONS_ID.Cine, ICONS_ID.CineIcon, ICONS_ID.CineN, ICONS_ID.CineRock, ICONS_ID.ClaveWifi, ICONS_ID.Clic, ICONS_ID.Cloud, ICONS_ID.Comedia, ICONS_ID.ComedyCentral, ICONS_ID.Compartir, ICONS_ID.Comprar, ICONS_ID.ComprarDatos, ICONS_ID.ComprarPlanes, ICONS_ID.CompraSegura, ICONS_ID.ConfianzaOnline, ICONS_ID.Configuracion, ICONS_ID.ConfiguracionCorreo, ICONS_ID.ConfiguracionRouter, ICONS_ID.ConfigurarMovil, ICONS_ID.ConsultaCanjes, ICONS_ID.ConsultaDocumento, ICONS_ID.Consumo, ICONS_ID.CorazonSalud, ICONS_ID.Dark, ICONS_ID.Datos, ICONS_ID.Deporte, ICONS_ID.Deporte1, ICONS_ID.Deporte2, ICONS_ID.DeporteIcon, ICONS_ID.Descargar, ICONS_ID.DescargarApp, ICONS_ID.Desco, ICONS_ID.DescoMando, ICONS_ID.DetalleLlamadas, ICONS_ID.Dialogando, ICONS_ID.Dinero, ICONS_ID.Directorio, ICONS_ID.Disney, ICONS_ID.Documento, ICONS_ID.Ecologico, ICONS_ID.Envio, ICONS_ID.Error, ICONS_ID.Estrenos, ICONS_ID.Euro, ICONS_ID.EuroCirculo, ICONS_ID.Eurosport, ICONS_ID.Facebook, ICONS_ID.Factura, ICONS_ID.Favorito, ICONS_ID.Fibra, ICONS_ID.Fijo, ICONS_ID.FijoInternet, ICONS_ID.Filtro, ICONS_ID.Formula1, ICONS_ID.Foro, ICONS_ID.Fox, ICONS_ID.FoxLife, ICONS_ID.FundacionTelefonica, ICONS_ID.Fusion, ICONS_ID.Futbol, ICONS_ID.FutbolIcon, ICONS_ID.Grabar, ICONS_ID.Global, ICONS_ID.Golf, ICONS_ID.Hgu, ICONS_ID.Hollywood, ICONS_ID.Home, ICONS_ID.HomeDoor, ICONS_ID.Juego, ICONS_ID.Informacion, ICONS_ID.Instagram, ICONS_ID.Internet, ICONS_ID.InternetMovil, ICONS_ID.Lanzamiento, ICONS_ID.LaLiga, ICONS_ID.LigaCampeones, ICONS_ID.LineaAdicional, ICONS_ID.Linkedin, ICONS_ID.LlamadaEntrante, ICONS_ID.LlamadaEspera, ICONS_ID.LlamadaSaliente, ICONS_ID.Mas80, ICONS_ID.Megusta, ICONS_ID.MensDictados, ICONS_ID.MisPedidos, ICONS_ID.Motor, ICONS_ID.MotorIcon, ICONS_ID.Movil, ICONS_ID.Movistar, ICONS_ID.MovistarCar, ICONS_ID.MovistarCircular, ICONS_ID.MovistarLikes, ICONS_ID.MovistarPlus, ICONS_ID.MpaUp, ICONS_ID.Multicontenido, ICONS_ID.Multipantalla, ICONS_ID.Noticias, ICONS_ID.NoVer, ICONS_ID.Nube, ICONS_ID.Nubico, ICONS_ID.Oferta, ICONS_ID.OfertasExclusivas, ICONS_ID.Ok, ICONS_ID.Ont, ICONS_ID.Opciones, ICONS_ID.PagarFacturas, ICONS_ID.PagoOnline, ICONS_ID.Partidazo, ICONS_ID.Perfil, ICONS_ID.Play, ICONS_ID.Portatil, ICONS_ID.PriorityUser, ICONS_ID.Producto, ICONS_ID.Qustodio, ICONS_ID.RealMadrid, ICONS_ID.RechazoLlamada, ICONS_ID.Reloj, ICONS_ID.Router, ICONS_ID.Seguridad, ICONS_ID.SeguridadAbierta, ICONS_ID.SeguroMovil, ICONS_ID.SeriesMania, ICONS_ID.Series, ICONS_ID.SeriesIcon, ICONS_ID.SeriesExtras, ICONS_ID.ServicioTecnicoMovil, ICONS_ID.Sim, ICONS_ID.SinConexion, ICONS_ID.Sms, ICONS_ID.SoporteTecnico, ICONS_ID.Star, ICONS_ID.SundanceTv, ICONS_ID.SYFY, ICONS_ID.TarjetaCredito, ICONS_ID.TaquillaUp, ICONS_ID.TCM, ICONS_ID.Telefonica, ICONS_ID.TelefonicaFanshop, ICONS_ID.Tiendas, ICONS_ID.Tokens, ICONS_ID.Tuenti, ICONS_ID.Tv, ICONS_ID.Twitter, ICONS_ID.Usuario, ICONS_ID.Ubicacion, ICONS_ID.UHD, ICONS_ID.U7D, ICONS_ID.Vamos, ICONS_ID.Ver, ICONS_ID.Video, ICONS_ID.ViolenciaDeGenero, ICONS_ID.WhatsappBlue, ICONS_ID.WhatsappGreen, ICONS_ID.Xtra, ICONS_ID.Youtube]).isRequired,

  /**
   * {
   *  "info": "Selecciona el color del icono",
   *  "kind": "both",
   *  "beautifulName": "",
   *  "injectComponent": ""
   * }
   */
  color: _propTypes["default"].oneOf([COLOR.BLACK, COLOR.BLUE, COLOR.GREEN, COLOR.GREY_7, COLOR.ORANGE, COLOR.PIPPER, COLOR.WHITE, COLOR.INHERIT, COLOR.EMP_DARK_BLUE]),

  /**
   * {
   *  "info": "Selecciona el trazo del icono, algunos no existen para determinados iconos id",
   *  "kind": "both",
   *  "beautifulName": "Trazo",
   *  "injectComponent": ""
   * }
   */
  kind: _propTypes["default"].oneOf([SVG_ICON_KIND.LIGHT, SVG_ICON_KIND.MEDIUM, SVG_ICON_KIND.SOLID]),

  /**
   * {
   *  "info": "Obliga al CustomLink inyectado a que utilice una <a> común en lugar de <Link>",
   *  "kind": "playground",
   *  "beautifulName": "",
   *  "injectComponent": ""
   * }
   */
  className: _propTypes["default"].string
};
SVGIconLoader.defaultProps = {
  kind: SVG_ICON_KIND.MEDIUM,
  className: '',
  color: COLOR.INHERIT
};
var _default = SVGIconLoader;
exports["default"] = _default;

//# sourceMappingURL=index.js.map